import PillList from './PillList';

export { PillList };

export default PillList;
